<template functional>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.9999 12.0001C23.9999 5.3728 18.6272 0.000194571 11.9999 0.000194571C5.37261 0.000194571 0 5.3728 0 12.0001C0 17.6276 3.8743 22.3498 9.10122 23.6468V15.6673H6.62675V12.0003H9.10122V10.4202C9.10122 6.33582 10.9496 4.44281 14.9596 4.44281C15.7198 4.44281 17.0316 4.59185 17.5682 4.74093V8.06511C17.285 8.0353 16.7931 8.02037 16.1819 8.02037C14.2143 8.02037 13.454 8.76571 13.454 10.7036V12.0004H17.3736L16.7003 15.6674H13.454V23.9123C19.3959 23.1947 24 18.1355 24 12.0002"
      fill="white"
    />
    <path
      d="M16.7001 15.6673L17.3735 12.0003H13.4539V10.7034C13.4539 8.76556 14.2141 8.02027 16.1817 8.02027C16.7929 8.02027 17.2848 8.03515 17.5681 8.06496V4.74083C17.0314 4.59175 15.7197 4.44266 14.9594 4.44266C10.9496 4.44266 9.10107 6.33582 9.10107 10.4201V12.0002H6.62659V15.6672H9.10107V23.6466C10.0295 23.8769 11.0003 24 12 24C12.4922 24 12.9771 23.9697 13.4538 23.9121V15.6672L16.7001 15.6673Z"
      fill="#0866FF"
    />
  </svg>
</template>

<script>
export default {
  name: "FbIcon"
};
</script>
